<template>
  <b-modal
    id="modal-photo"
    ref="bModal"
    size="xl"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    :title="$t('grossing.modal.capture')"
    centered
    static
    modal-class="photoModal"
  >
    <b-row class="header-float">
      <b-col class="header px-5 py-3">
        <b-row class="d-flex align-items-center">
          <b-col>
            <b-row class="d-flex align-items-center">
              <b-col>
                <div class="form-label">
                  <label>
                    {{ $t('grossing.modal.zoom') }}
                  </label>
                </div>
                <b-form-input
                  id="range-1"
                  v-model="rangeValue"
                  type="range"
                  min="0"
                  max="100"
                />
              </b-col>
              <b-col cols="2">
                <div>{{ rangeValue }}</div>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            cols="auto"
            class="d-flex flex-column align-items-center"
          >
            <div class="form-label mr-2">
              <label>{{ $t('grossing.modal.watermark') }}</label>
            </div>
            <div class="d-flex mt-1">
              <input
                id="toggle1"
                v-model="withWatermark"
                type="checkbox"
                class="offscreen"
                aria-hidden="true"
              > <label
                for="toggle1"
                class="switch m-0"
              />
              <b-form-input
                v-model="watermarkColor"
                class="color-selector ml-1"
                type="color"
                :disabled="!withWatermark"
              />
              <b-form-input
                v-model="watermarkFontSize"
                class="text-size-selector ml-1"
                type="number"
                min="10"
                max="999"
                :disabled="!withWatermark"
              />
            </div>
          </b-col>
          <!-- <b-col cols="3">
            <div class="form-label">
                <label>
                  {{$t('grossing.modal.destination')}}
                </label>
              </div>
              <div style="position:relative">
                <vt-input class="form-control-sm" style="padding-right: 30px" />
                <i class="fal fa-barcode-alt iconbarcode" aria-hidden="true"></i>
              </div>
          </b-col> -->
          <b-col cols="auto">
            <b-button
              v-tooltip="$t('grossing.modal.takePhoto')"
              size="sm"
              class="circle-btn mr-2"
              :disabled="videoRecording"
              @click="takePhoto"
            >
              <i
                aria-hidden="true"
                class="fal fa-camera"
              />
            </b-button>
            <b-button
              v-if="videoRecording"
              v-tooltip="$t('grossing.modal.stopVideoRecording')"
              size="sm"
              class="circle-btn recording-btn"
              @click="stopRecordingVideo"
            >
              <i
                aria-hidden="true"
                class="fal fa-video"
              />
            </b-button>
            <b-button
              v-else
              v-tooltip="$t('grossing.modal.startVideoRecording')"
              size="sm"
              class="circle-btn"
              @click="startRecordingVideo"
            >
              <i
                aria-hidden="true"
                class="fal fa-video"
              />
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row
      class="h-100"
      style="overflow:hidden"
    >
      <b-col>
        <b-row class="h-100">
          <b-col class="p-0 photo-space d-flex align-items-center justify-content-center">
            <video
              id="cam"
              ref="videocam"
              class="videocam"
              playsinline
              autoplay
            />
          </b-col>
          <b-col
            v-show="photoTaken || videoRecorded"
            class="p-0 photo-space d-flex align-items-center justify-content-center"
          >
            <canvas
              v-show="photoTaken"
              ref="canvas"
              class="canvas"
            />
            <video
              v-show="videoRecorded"
              id="videoRecorded"
              ref="videoplayer"
              class="videoplayer"
              playsinline
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-4 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.close') }}
          </b-button>
        </div>
        <div
          class="col-4 text-center"
          :class="{'timeAlarm':isTimeAlarm}"
        >
          <span v-if="videoRecording">
            {{ $tc('grossing.modal.remainingTime') + ':' + timeRemaining + ' ' + $tc('grossing.modal.minutes') }}
          </span>
        </div>
        <div class="col-4 text-right">
          <b-button
            v-if="videoRecorded"
            size="sm"
            class="btn--primary downloadButton"
            @click="downloadFile"
          >
            <i
              aria-hidden="true"
              class="fal fa-save mr-2"
            />
            {{ $tc('grossing.modal.downloadVideo') }}
          </b-button>

          <b-button
            size="sm"
            class="btn--primary"
            :disabled="!photoTaken && !videoRecorded"
            @click="attachFile"
          >
            <i
              aria-hidden="true"
              class="fal fa-save mr-2"
            />
            {{ $t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { DateUtils } from '@/shared/util/date-utils'
import attachmentTypeService from '@/api/resources/attachment/attachmentTypeService'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import apiExceptionType from '@/utils/apiExceptionType'
import { SupportedFileType } from '@/shared/models/common.models'

const sampleAttachmentService = () => import('@/api/resources/attachment/sampleAttachmentService')

export default {
    name: 'PhotoModal',
    props: {
        sampleLabel: { type: String, required: true },
        entitiesIdArray: { type: Array },
        attachmentEntityType: { type: String }
    },
    data() {
        return {
            selected: null,
            options: [],
            rangeValue: '30',
            mediaRecorder: null,
            recordedBlobs: [],
            photoTaken: false,
            videoRecording: false,
            videoRecorded: false,
            fileToSave: null,
            withWatermark: false,
            watermarkColor: '#FFFFFF',
            watermarkFontSize: 36,
            watermarkBackgroundColor: '#000000',
            attachmentCall: null,
            mediaStream: null,
            startRecordTime: 0,
            maxTimeToStop: 600000,
            pendingTimeToStop: 0,
            timeAlarmLimit: 20000
        }
    },
    computed: {
        timeRemaining() {
            return this.millisToMinutesAndSeconds(this.pendingTimeToStop)
        },
        isTimeAlarm() {
            return this.pendingTimeToStop < this.timeAlarmLimit && this.pendingTimeToStop > 0
        }
    },
    mounted() {
        if (this.$refs.videocam) {
            this.$refs.canvas.width = this.$refs.videocam.videoWidth
            this.$refs.canvas.height = this.$refs.videocam.videoHeight
        }
        this.pendingTimeToStop = 0
        this.maxTimeToStop = this.$_globalParameters.maxVideoRecordTime * 60000
    },
    methods: {
        millisToMinutesAndSeconds(millis) {
            let minutes = Math.floor(millis / 60000)
            let seconds = ((millis % 60000) / 1000).toFixed(0)
            return minutes + ':' + (seconds < 10 ? '0' : '') + seconds
        },
        async addAttachment() {
            switch (this.attachmentEntityType) {
            case ATTACHMENT_ENTITY_TYPE.SAMPLE:
                await sampleAttachmentService().then(service => {
                    this.attachmentCall = service.default
                    this.errorMessage = 'component.attachModal.error.sampleAttachmentError'
                })
                break
            }
            if (this.attachmentCall) {
                return this.addAttachmentsCall()
            }
            return false
        },
        async addAttachmentsCall() {
            this.updateLoading(true)
            const call = this.attachmentCall.addAttachment(...this.entitiesIdArray, this.fileToSave.attachmentType.atyId, this.fileToSave.file)
            const [err, response] = await this.toCall(call)
            this.updateLoading(false)
            if (err) {
                if (err.response && (err.response.data.code === apiExceptionType.MAX_UPLOAD_SIZE_EXCEEDED ||
                        err.response.status === apiExceptionType.ENTITY_TOO_LARGE)) {
                    this.showErrorModalGlobal(this.$t('component.attachModal.error.maxFileSizeExceeded'))
                } else {
                    this.showErrorModalGlobal(this.$t(this.errorMessage))
                }
                return false
            }
            this.showToastSuccessGlobal()
            this.$emit('attachmentsAdded', [response])
            return true
        },
        async attachFile() {
            if (await this.addAttachment()) {
                this.hide()
            }
        },
        async downloadFile() {
            this.$_downloadFile(this.fileToSave.file, this.fileToSave.file.name, SupportedFileType.VIDEO_WEBM)
        },
        async takePhoto() {
            this.photoTaken = true
            this.videoRecorded = false
            this.$refs.canvas.width = this.$refs.videocam.videoWidth
            this.$refs.canvas.height = this.$refs.videocam.videoHeight
            this.$refs.canvas.getContext('2d').drawImage(this.$refs.videocam, 0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
            this.addWatermark()
            const filename = `capture ${DateUtils.formatDate(new Date(), DateUtils.dateTimeWithSecondsPattern)}`
            const file = attachmentTypeService.base64ToBlob(this.$refs.canvas.toDataURL('image/png'), filename)
            const thumbnailBytes = await attachmentTypeService.thumbnailify(this.$refs.canvas.toDataURL('image/png'))
            const attachmentType = await attachmentTypeService.getAttachmentType(this.attachmentEntityType, 'attachment.type.macroscopicimage.code')
            this.fileToSave = { 'attachmentType': { 'atyId': attachmentType.atyId }, file, thumbnailBytes }
        },
        startRecordingVideo() {
            this.photoTaken = false
            this.videoRecording = true
            this.videoRecorded = false
            this.startRecordTime = Date.now()
            this.pendingTimeToStop = this.maxTimeToStop

            this.recordedBlobs = []
            let options = { mimeType: 'video/webm;codecs=vp9' }

            if (!MediaRecorder.isTypeSupported(options.mimeType)) {
                options = { mimeType: 'video/webm;codecs=vp8' }

                if (!MediaRecorder.isTypeSupported(options.mimeType)) {
                    options = { mimeType: 'video/webm' }

                    if (!MediaRecorder.isTypeSupported(options.mimeType)) {
                        options = { mimeType: '' }
                    }
                }
            }

            try {
                this.mediaRecorder = new MediaRecorder(this.mediaStream, options)
            } catch (e) {
                this.showErrorModalGlobal(this.$t(`grossing.modal.errorWhileRecording`))
                return
            }

            this.mediaRecorder.ondataavailable = this.handleDataAvailable
            this.mediaRecorder.start(10) // collect 10ms of data
        },
        async stopRecordingVideo() {
            this.pendingTimeToStop = 0
            this.videoRecording = false
            this.videoRecorded = true
            this.mediaRecorder.stop()
            let file = new Blob(this.recordedBlobs, { type: 'video/webm' })
            file.name = `video capture ${DateUtils.formatDate(new Date(), DateUtils.dateTimeWithSecondsPattern)}`

            this.$refs.videoplayer.src = null
            this.$refs.videoplayer.srcObject = null
            this.$refs.videoplayer.src = window.URL.createObjectURL(file)
            this.$refs.videoplayer.controls = true

            this.$refs.canvas.width = this.$refs.videocam.videoWidth
            this.$refs.canvas.height = this.$refs.videocam.videoHeight
            this.$refs.canvas.getContext('2d').drawImage(this.$refs.videocam, 0, 0, this.$refs.canvas.width, this.$refs.canvas.height)

            const thumbnailBytes = await attachmentTypeService.thumbnailify(this.$refs.canvas.toDataURL('image/png'))
            const attachmentType = await attachmentTypeService.getAttachmentType(this.attachmentEntityType, 'attachment.type.macroexaminationvideo.code')
            this.fileToSave = { 'attachmentType': { 'atyId': attachmentType.atyId }, file, thumbnailBytes }
        },
        handleSuccess(stream) {
            this.mediaStream = stream
            if (this.$refs.videocam) {
                this.$refs.videocam.srcObject = stream
            }
            this.$refs.bModal.show()
        },
        handleError() {
            this.showErrorModalGlobal(this.$t(`grossing.modal.errorCameraNotDetected`))
        },
        handleDataAvailable(event) {
            this.pendingTimeToStop = this.maxTimeToStop - (Date.now() - this.startRecordTime)
            if (event.data && event.data.size > 0) {
                this.recordedBlobs.push(event.data)
            }
            if (this.pendingTimeToStop <= 0) {
                this.pendingTimeToStop = 0
                this.stopRecordingVideo()
            }
        },
        addWatermark() {
            if (this.withWatermark) {
                let canvasContext = this.$refs.canvas.getContext('2d')
                canvasContext.font = `${this.watermarkFontSize}px verdana`
                let textWidth = canvasContext.measureText(this.sampleLabel).width
                canvasContext.globalAlpha = 0.50

                canvasContext.shadowColor = this.watermarkBackgroundColor
                canvasContext.shadowBlur = 7
                canvasContext.lineWidth = 5
                canvasContext.strokeText(this.sampleLabel, this.$refs.canvas.width - textWidth - 10 + 2, this.$refs.canvas.height - 20 + 2)
                canvasContext.shadowBlur = 0
                canvasContext.fillStyle = this.watermarkColor
                canvasContext.fillText(this.sampleLabel, this.$refs.canvas.width - textWidth - 10 + 2, this.$refs.canvas.height - 20 + 2)
            }
        },
        hide() {
            this.mediaStream.getTracks().forEach(track => track.stop())
            this.$refs.canvas.getContext('2d').clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
            this.$refs.bModal.hide()
        },
        show() {
            this.photoTaken = false
            this.videoRecording = false
            this.videoRecorded = false
            this.recordedBlobs = []
            this.fileToSave = null
            this.withWatermark = false
            this.watermarkColor = '#FFFFFF'
            this.watermarkBackgroundColor = '#000000'
            let constraints = {
                audio: true,
                video: {
                    width: { ideal: 4096 },
                    height: { ideal: 2160 }
                }
            }
            navigator.mediaDevices.getUserMedia(constraints).then(this.handleSuccess).catch(this.handleError)
        }
    }
}
</script>

<style>

  .photoModal .modal-body {
    padding: 0 1.1rem 0 1.1rem !important;
    height: calc(100vh - 250px);
    position: relative;
  }

</style>

<style lang="scss" scoped>

  .photoModal {
    color: #303133;
  }

  .photoModal .header {
    border-bottom: 1px solid #dee2e6;
    background: rgba(255, 255, 255, 0.9);;
  }

  .photoModal .header-float {
    position: absolute;
    width: 100%;
    z-index: 2;
  }

  .photoModal .circle-btn {
    width: 45px;
    height: 45px;
    background: vt-color(primary);
    border-radius: 50%;
    border-color: transparent;
    padding: 0;
    font-size: 20px;
  }

  .photoModal .circle-btn:hover {
    background: #5a6268;
  }

  .photoModal .recording-btn {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border-color: transparent;
    padding: 0;
    font-size: 20px;
    animation: recording .75s infinite alternate;
  }

  @keyframes recording {
    0% {
      background: vt-color(red);
    }
    33% {
      background: vt-color(red);
    }
    100% {
      background: vt-color(primary);
    }
  }

  .photoModal .iconbarcode {
    position: absolute;
    right: 6px;
    top: 6px;
  }

  .photoModal .photo-space {
    height: 100%;
  }

  .photoModal .photo-space img {
    width: 45%;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    transition: all 0.3s;
  }

  .switch::after {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 18px;
    background-color: white;
    top: 1px;
    left: 1px;
    transition: all 0.3s;
  }

  input[type='checkbox']:checked + .switch::after {
    transform: translateX(20px);
  }

  input[type='checkbox']:checked + .switch {
    background-color: vt-color(primary);
  }

  .offscreen {
    position: absolute;
    left: -9999px;
  }

  .color-selector {
    width: 30px;
    height: 30px !important;
    border-color: transparent;
    margin-top: -5px;
  }

  .text-size-selector {
    width: 65px;
    height: 30px !important;
    border-color: transparent;
    margin-top: -5px;
  }

  .videocam {
    width: 100%
  }

  .canvas {
    width: 100%
  }

  .videoplayer {
    width: 100%
  }

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }

  .timeAlarm{
    color: red;
    font-weight: bold;
    animation: blinker 1s linear infinite;
  }

  .downloadButton{
    margin-right: 20px;
  }

</style>
